export class BaseLayerBox {
    constructor(opts, multiBaseLayersEnabled) {
        this.multiBaseLayersEnabled = multiBaseLayersEnabled;
        this.layers = [];
        this.layers = [];
        this.header = $();
        this.body = $();
        this.render_index = opts.render_index;
        this.ui_index = opts.ui_index;
        this.filter = l => l.is_base;
    }
    add_layers(layers) {
        this.layers = layers.filter(this.filter);
        this.build_ui();
    }
    no_baselayer_input() {
        const input = $(`<input type="radio" id="disable_baseLayers" name="baseLayers" value="disable_baseLayers" />`)
            .on('click', () => {
            if (this.layers.some(l => l.visible)) {
                this.layers.forEach(l => l.visible = false);
                input.prop('checked', true);
            }
        });
        return input;
    }
    base_html() {
        const label = $(`<label><span>None</span></label>`).prepend(this.no_baselayer_input());
        return $(`<div class="layerType base"></div>`).append($(`<div class="layer"></div>`).append(label));
    }
    build_ui() {
        const $baseheader = $('<div class="header">Base</div><hr class="layerbox-hr" />');
        const $baseDiv = this.base_html();
        this.layers.forEach(layer => {
            layer.ui.map(ui => $baseDiv.append(ui));
        });
        let is_visible = this.layers.some(l => l.is_base && l.visible && !l.parsing_failed);
        if (!is_visible) {
            let baselayer = this.layers.find(l => l.is_base && !l.parsing_failed);
            if (baselayer) {
                baselayer.visible = true;
                baselayer.ui.map(ui => {
                    ui.find('input').prop("checked", true);
                });
            }
            else {
                throw new Error("No baselayer defined in config. Cannot continue");
            }
        }
        if (!this.multiBaseLayersEnabled) {
            $baseDiv.on('base_layer_select', (_event, datatuple) => {
                this.layers.filter(l => l.name !== datatuple).forEach(layer => layer.visible = false);
            });
        }
        this.header = $baseheader;
        this.body = $baseDiv;
    }
}
